// Auto-generated by set-version.js
export const buildInfo = {
  version: '1.0.0',
  hash: 'TEMP-4GW00C',
  builtAt: '2026-11-05T11:57:43.267Z'
};
